import { Directive, ElementRef, EventEmitter, Output, OnInit } from '@angular/core';
import { GoogleMapsLoaderService } from '../../core/services/google-maps-loader.service';
import { ConfigService } from '@core/services/config.service';

declare const google: any;

@Directive({
  selector: '[mapAutoComplete]'
})
export class MapAutoCompleteDirective implements OnInit {
  @Output() mapSearch = new EventEmitter();

  constructor(
    private readonly eleRef: ElementRef,
    private readonly googleMapsLoader: GoogleMapsLoaderService,
    private readonly configService: ConfigService
  ) {}

  async ngOnInit() {
    await this.googleMapsLoader.load(); // Wait until API is ready

    const input = this.eleRef.nativeElement as HTMLInputElement;
    const autocomplete = new google.maps.places.Autocomplete(input);

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (!place.geometry) return;

      const lat = place.geometry.location?.lat();
      const lng = place.geometry.location?.lng();

      const formattedLocation = {
        country: place.address_components?.find(c => c.types.includes('country'))?.long_name || '',
        state: place.address_components?.find(c => c.types.includes('administrative_area_level_1'))?.long_name || '',
        latitude: lat,
        longitude: lng,
        address: place.formatted_address || '',
        streetView: `${this.configService.get('mapUrls').streetView}${lat},${lng},16z?hl=en&q=${lat},${lng}`
      };

      this.mapSearch.emit(formattedLocation);
    });
  }
}
